import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MySocketWrapper } from './socket-wrapper';
import { urls } from 'src/app/utils/url-utils';
@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(private socket: MySocketWrapper) {

    this.socket.on('connect', () => {

    });

    this.socket.on('disconnect', () => {
    });
  }

  getSocket() {
    return this.socket;
  }

  emit(event, payload?) {

    this.socket.emit(event, payload);
  }

  addListener(event): Observable<any> {
    return this.socket.fromEvent(event).pipe(
      map(data => {
        return data;
      })

    );

  }

  removeListener(event) {
    this.socket.removeListener(event, () => {
    });
  }


  connectSocket() {
    if (!this.socket.ioSocket.connected) {
      this.socket.ioSocket.io.opts.query = { auth_token: JSON.parse(localStorage.getItem('token')) } //new options
      // this.socket.ioSocket.io.uri = urls.SERVER_URL //new uri
      this.socket.connect(); //manually connection

    }
  }

  disconnectSocket() {
    if (this.socket.ioSocket.connected) {
      this.socket.removeAllListeners();
      this.socket.disconnect();
    }
  }
}
